import { render, staticRenderFns } from "./ModuleConfigurator.vue?vue&type=template&id=c7b6e6ae"
import script from "./ModuleConfigurator.vue?vue&type=script&lang=js"
export * from "./ModuleConfigurator.vue?vue&type=script&lang=js"
import style0 from "./ModuleConfigurator.vue?vue&type=style&index=0&id=c7b6e6ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports